const defaultState = {
  tabs: [
    {
      path: 'details',
      title: 'Details',
    },
    {
      path: 'claims',
      title: 'Claims',
    },
    {
      path: 'dockets',
      title: 'Dockets',
    },
  ],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/caseMenu.js